import React from "react";
import visonImg from "../../Assests/AboutUs/VisionAndMission1.png";
import missionImg from "../../Assests/AboutUs/VisionAndMission2.png";

function MissionAndVision() {
  return (
    <div className="MissionAndVision  py-5 ">
      <div className="container MissionAndVision-container p-5">
        <div className="mt-5">
          <div className="fw-bold fs-1 missionandvisiontextcolor mission-vision-main-text">
            Our Mission and Vision
          </div>
        </div>

        <div className="row w-100 mt-5 m-0">
          <div className="col-md-6">
            <div className="d-flex justify-content-center align-items-center p-2">
              {" "}
              <img src={visonImg} className="vison-mission-image" style={{ width: "85%" }} alt="visonImg" />
            </div>
          </div>
          <div className="col-md-6">
            <div className="mt-5 mission-mobile-main" style={{ width: "83%" }}>
              <div className="missionandvisiontextcolor fw-bold fs-4 mt-5 mission">
                Mission
              </div>

              <div className="mt-3 fs-4 mission-vision-content mission-vision-content-mobile">
                Vizzhy is committed to transforming healthcare through
                personalized, predictive solutions that detect health risks
                early, empowering proactive prevention and timely interventions
                tailored to each individual’s unique biology.
              </div>
            </div>
          </div>
        </div>

        <div className="row w-100 mt-5 vision-row">
          <div className="col-md-6">
            <div className="mt-5 vission-mobile-main" style={{ width: "83%" }}>
              <div className="missionandvisiontextcolor fw-bold fs-4 vision">
                Vision
              </div>
              <div className="mt-3 fs-4 mission-vision-content mission-vision-content-mobile">
              We aim to shift healthcare from treatment to prevention addressing the root causes of metabolic 
              disorders by focusing on predictive, preventive, and personalized care. We empower individuals to 
              make informed, data-driven health decisions for improved long-term wellness.
              </div>
            </div>
          </div>
          <div className="col-md-6 mb-5">
            <div className="d-flex justify-content-center align-items-center p-2">
              {" "}
              <img src={missionImg} className="vison-mission-image" style={{ width: "85%" }} alt="missionImg" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MissionAndVision;
